import { mgmType } from "./type";

const initialAuthState = {
  mgmList: null,
  isLoading: false,
  statusCode: null
};

export const reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case mgmType.GET_MGM_LIST_REQUEST:
      return { ...state, isLoading: true };
    case mgmType.GET_MGM_LIST_SUCCESS:
      return { ...state, isLoading: false, mgmList: action.payload.data };
    case mgmType.GET_MGM_LIST_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return state;
  }
};
